import React from "react";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import S from "./TitleV1.module.scss";

interface V1Props {
    title?: string;
}

const V1 = ({ title }: V1Props) => {
    return title ? (
        <DA_Container noTopPadding noBottomPadding>
            <div className={S.categoryHeading}>
                {title ? (
                    <DA_Title fullWidth h1>
                        {title}
                    </DA_Title>
                ) : null}
            </div>
        </DA_Container>
    ) : null;
};

export default V1;
